import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { MyBidsPage } from '@/features/bids/my-bids-page';

/** Обрана група — в адресі: посилання на «ставки, де від мене чекають дії» має бути посиланням. */
const GROUPS = ['action', 'floor', 'pending', 'result', 'won', 'closed'];

export const Route = createFileRoute('/bids')({
	validateSearch: (raw: Record<string, unknown>): { group?: string } => {
		const group = typeof raw.group === 'string' && GROUPS.includes(raw.group) ? raw.group : undefined;
		return { group };
	},
	/** Лише для автентифікованих; гостя ведемо на вхід і повертаємо сюди. */
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: '/bids' } });
	},
	component: MyBidsPage,
	staticData: { workspace: true },
});
